export default {
  brand: "AllChinaBuy Spreadsheet",
  brandShort: "ACB Spreadsheet",
  tagline: "Das AllChinaBuy-Ressourcencenter",
  independentNote: "Dies ist eine unabhängige Informationsressource und nicht die offizielle AllChinaBuy-Website.",

  nav: {
    home: "Startseite",
    spreadsheet: "Spreadsheet",
    categories: "Kategorien",
    guides: "Guides",
    shoppingGuide: "Kauf-Guide",
    browseCategories: "Kategorien durchstöbern",
    faq: "FAQ",
  },

  hero: {
    eyebrow: "DAS ALLCHINABUY-RESSOURCENCENTER",
    title: "AllChinaBuy Spreadsheet — Entdecke bessere Funde, Verkäufer & Kauf-Guides",
    subtitle: "Erkunde organisierte AllChinaBuy Spreadsheet-Funde, Produktkategorien, QC-Ressourcen, Verkäuferinformationen, Versand-Guides und praktische Kauftipps — alles an einem Ort.",
    ctaPrimary: "AllChinaBuy Spreadsheet",
    ctaSecondary: "Jetzt kaufen",
    trust: "Unabhängige Ressource • Aktualisierte Guides • Käuferorientierte Informationen",
    searchPlaceholder: "AllChinaBuy Spreadsheet, Schuhe, Hoodies, QC, Versand suchen...",
  },

  cards: {
    findsTitle: "Organisierte Funde",
    findsDesc: "Durchstöbere kuratierte AllChinaBuy Spreadsheet-Ressourcen nach Kategorie und Produkttyp.",
    qcTitle: "QC-Ressourcen",
    qcDesc: "Lerne, QC-Fotos, Produktdetails und Verkäuferinformationen zu verstehen.",
    shippingTitle: "Versand-Guides",
    shippingDesc: "Verstehe internationale Versandoptionen, Kosten und häufige Überlegungen.",
    buyingTitle: "Kauf-Guides",
    buyingDesc: "Folge praktischen Guides für Anfänger und erfahrene Käufer.",
  },

  preview: {
    title: "AllChinaBuy Spreadsheet-Vorschau",
    subtitle: "Ein schneller Blick darauf, wie unser Spreadsheet Funde, QC-Status und Verkäuferinformationen organisiert.",
    colProduct: "Produkt",
    colCategory: "Kategorie",
    colQc: "QC",
    colSeller: "Verkäufer",
    colStatus: "Status",
    updated: "Aktualisiert",
    fresh: "Neu",
    verified: "Verifizierte Info",
    sellerInfo: "Verkäuferinfo",
  },

  categories: {
    title: "Produktkategorien durchstöbern",
    subtitle: "Springe direkt zu jeder Kategorie auf der Hauptwebsite und erkunde organisierte AllChinaBuy Spreadsheet-Funde.",
    dropdownLabel: "Kategorie wählen",
    shoes: "Schuhe",
    hoodies: "Hoodies/Sweater",
    tshirts: "T-Shirts",
    jackets: "Jacken",
    pants: "Hosen/Shorts",
    headwear: "Kopfbedeckung",
    sets: "Sets",
    underwear: "Unterwäsche/Unterhosen",
    jersey: "Trikots",
    accessories: "Accessoires",
    bags: "Taschen",
    belts: "Gürtel",
    perfumes: "Parfums",
    other: "Sonstiges",
  },

  content: {
    title: "Was ist das AllChinaBuy Spreadsheet?",
    p1: "Das AllChinaBuy Spreadsheet ist eine strukturierte Ressource, die Produktfunde, Verkäuferinformationen, Qualitätskontroll-Notizen (QC) und Versanddetails an einem Ort organisiert. Statt durch verstreute Angebote zu scrollen, nutzen Käufer es, um Optionen nebeneinander zu vergleichen und fundiertere Entscheidungen zu treffen, bevor sie bestellen.",
    p2: "Ein gut organisiertes AllChinaBuy Spreadsheet gruppiert Produkte typischerweise nach Kategorie — Schuhe, Hoodies, T-Shirts, Jacken, Taschen und Accessoires — und ergänzt dann praktische Felder wie QC-Status, Verkäufer-Zuverlässigkeit und letztes Aktualisierungsdatum. Diese Struktur hilft sowohl Erstkäufern als auch erfahrenen Shopper*innen, Qualitätsartikel schneller zu erkennen.",
    p3: "Über die Produktentdeckung hinaus dient das Spreadsheet als Kauf-Guide. Es kann Notizen enthalten, wie man QC-Fotos liest, Verkäufer bewertet und worauf man beim internationalen Versand achten sollte. Kombiniert mit unseren Kauf-Guides verwandelt es eine rohe Liste in ein echtes Entscheidungswerkzeug.",
    linkLabel: "Den vollständigen AllChinaBuy Spreadsheet-Guide lesen",
  },

  articleEntry: {
    title: "Empfohlener Guide",
    subtitle: "Originale, tiefgehende Ressourcen rund um das AllChinaBuy Spreadsheet-Thema.",
    cardTitle: "AllChinaBuy Spreadsheet: Der Komplette Käufer-Guide",
    cardDesc: "Lerne, das AllChinaBuy Spreadsheet zu nutzen, Verkäufer zu bewerten, QC-Fotos zu lesen und Produkte mit Vertrauen zu wählen.",
    readMore: "Guide lesen",
  },

  pillars: {
    title: "Entdecke unsere Kauf-Guides",
    subtitle: "Originale, tiefgehende Ressourcen zu Tests, Versand, QC, Verkäufern, Sicherheit und mehr — alle rund um das AllChinaBuy Spreadsheet.",
    readMore: "Weiterlesen",
    minRead: "Min. Lesezeit",
  },

  faq: {
    title: "Häufig gestellte Fragen",
    q1: "Ist dies die offizielle AllChinaBuy-Website?",
    a1: "Nein. Dies ist eine unabhängige Informationsressource, die Käufern hilft, AllChinaBuy Spreadsheet-Funde, QC-Tipps und Versand-Guides zu verstehen und zu nutzen. Sie ist nicht mit der offiziellen AllChinaBuy-Plattform verbunden.",
    q2: "Was finde ich im AllChinaBuy Spreadsheet?",
    a2: "Organisierte Produktfunde in Kategorien wie Schuhe, Hoodies, T-Shirts, Jacken, Taschen und Accessoires — jeweils mit nützlichen Feldern wie QC-Status, Verkäuferinformationen und letztem Aktualisierungsdatum.",
    q3: "Wie funktionieren die Kategorien?",
    a3: "Jeder Kategorie-Button und das Dropdown führen dich direkt zum passenden Bereich auf der Hauptwebsite, wo du Produkte in dieser Kategorie durchstöbern kannst.",
    q4: "Wo kann ich diese Produkte tatsächlich kaufen?",
    a4: "Alle Produkte sind auf der Hauptwebsite verfügbar. Nutze die Buttons \"AllChinaBuy Spreadsheet\" oder \"Jetzt kaufen\", um dorthin zu gelangen.",
  },

  footer: {
    aboutTitle: "Über diese Website",
    aboutDesc: "Ein unabhängiges AllChinaBuy Spreadsheet- und Käuferressourcencenter. Wir helfen dir, Produkte schneller zu finden und mit besseren Informationen einzukaufen.",
    exploreTitle: "Entdecken",
    disclaimer: "Dies ist eine unabhängige Informationsressource und nicht die offizielle AllChinaBuy-Website, sofern nicht ausdrücklich angegeben.",
    rights: "Alle Rechte vorbehalten.",
  },

  languages: {
    en: "English",
    fr: "Français",
    da: "Dansk",
    de: "Deutsch",
  },
};